module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 16
// module chunks = 0